'use client';
import React, { useRef } from 'react';
import Link from 'next/link';

const categories = [
  { id: 'cat-all', label: 'Tous', emoji: '🔍', count: 341 },
  { id: 'cat-lifestyle', label: 'Lifestyle', emoji: '✨', count: 42 },
  { id: 'cat-beauty', label: 'Beauty', emoji: '💄', count: 38 },
  { id: 'cat-tech', label: 'Tech', emoji: '💻', count: 29 },
  { id: 'cat-food', label: 'Food', emoji: '🍽️', count: 31 },
  { id: 'cat-fashion', label: 'Fashion', emoji: '👗', count: 24 },
  { id: 'cat-comedy', label: 'Comedy', emoji: '😂', count: 19 },
  { id: 'cat-sport', label: 'Sport', emoji: '⚽', count: 16 },
  { id: 'cat-gaming', label: 'Gaming', emoji: '🎮', count: 11 },
  { id: 'cat-travel', label: 'Travel', emoji: '✈️', count: 18 },
  { id: 'cat-education', label: 'Education', emoji: '📚', count: 13 },
  { id: 'cat-automotive', label: 'Auto', emoji: '🚗', count: 8 },
  { id: 'cat-business', label: 'Business', emoji: '💼', count: 15 },
  { id: 'cat-ugc', label: 'UGC', emoji: '📱', count: 33 },
  { id: 'cat-new-talents', label: 'New Talents', emoji: '🌟', count: 22 },
  { id: 'cat-certified', label: 'Certifiés', emoji: '✅', count: 87 },
  { id: 'cat-top', label: 'Top Performing', emoji: '🏆', count: 20 },
];

export default function StoriesRow() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (dir: 'left' | 'right') => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: dir === 'right' ? 240 : -240, behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-3">
      <div className="flex items-center justify-between mb-3">
        <span className="text-[13px] font-600 text-foreground">Catégories</span>
        <div className="flex items-center gap-1.5">
          <button
            onClick={() => scroll('left')}
            className="p-1 rounded bg-muted hover:bg-border text-muted-foreground hover:text-foreground transition-all"
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6" /></svg>
          </button>
          <button
            onClick={() => scroll('right')}
            className="p-1 rounded bg-muted hover:bg-border text-muted-foreground hover:text-foreground transition-all"
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6" /></svg>
          </button>
        </div>
      </div>
      <div
        ref={scrollRef}
        className="flex items-center gap-2 overflow-x-auto hide-scrollbar"
      >
        {categories.map((cat, idx) => (
          <Link
            key={cat.id}
            href="/find-a-creator"
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md border text-[12px] font-500 whitespace-nowrap flex-shrink-0 transition-all duration-150 ${
              idx === 0
                ? 'bg-primary/15 border-primary/40 text-primary' :'bg-muted border-border text-muted-foreground hover:border-primary/30 hover:text-foreground hover:bg-muted/80'
            }`}
          >
            <span className="text-sm">{cat.emoji}</span>
            <span>{cat.label}</span>
            <span className={`text-[10px] font-700 px-1 py-0.5 rounded ${idx === 0 ? 'bg-primary/20 text-primary' : 'bg-border text-muted-foreground'}`}>
              {cat.count}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}